'use client';

import type { ReactNode } from 'react';
import './mobile-navigation-bar.scss';

interface Props {
  onBack: () => void;
  onNext?: () => void;
  backLabel?: string;
  nextLabel?: string;
  gradient?: boolean;
  children?: ReactNode;
}

export default function MobileNavigationBar({
  onBack,
  onNext,
  backLabel = 'BACK',
  nextLabel = 'NEXT',
  gradient = true,
  children,
}: Props) {
  return (
    <div className='mobile-navigation-bar'>
      {gradient && <div className='mobile-navigation-bar-gradient' />}
      {children}
      <div className='mobile-navigation-bar-buttons'>
        <button
          type='button'
          className='mobile-navigation-bar-button'
          onClick={onBack}
        >
          {backLabel}
        </button>
        {onNext && (
          <button
            type='button'
            className='mobile-navigation-bar-button'
            onClick={onNext}
          >
            {nextLabel}
          </button>
        )}
      </div>
    </div>
  );
}
